import { isPortalBuild } from './appTarget';
import { getPortalWebUrl } from './portalAuth';

/**
 * Portal 빌드에 존재하는 라우트 접두사.
 *
 * 여기 없는 web 경로는 Portal에 404라 Portal 빌드에서는 web 도메인 절대 주소로 본낸다.
 * Portal 빌드에 화면을 추가하면 이 목록도 함께 갱신한다.
 */
export const portalRoutePrefixes = [
  '/',
  '/auth/callback',
  '/auth/logged-out',
  '/documents',
  '/runs',
  '/invitations',
  // 러너 요청 모달의 실행 목록 바로가기용. Portal 실체는 /runs로 넘긴다.
  '/daemon-triggers',
] as const;

/** root-relative 경로(`/path?query`)가 Portal 라우트인지 판정한다. 쿼리·해시는 매칭에서 제외한다. */
export const isPortalRoute = (path: string) => {
  const pathname = path.split(/[?#]/, 1)[0];
  return portalRoutePrefixes.some((prefix) =>
    prefix === '/' ? pathname === '/' : pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
};

/**
 * 공용 코드가 가리키는 web 전용 경로를 현재 빌드 타깃 기준 href로 변환한다.
 *
 * - web 빌드: 항상 입력 그대로 반환한다(기존 동작 불변).
 * - Portal 빌드: Portal 라우트는 그대로, 아닌 경로는 web 도메인 절대 주소로 변환한다.
 * - root-relative가 아닌 값(외부 URL, 프로토콜 상대, 상대 경로)은 항상 그대로 둔다.
 */
export const resolveAppHref = (path: string) => {
  if (!isPortalBuild) return path;
  if (!path.startsWith('/') || path.startsWith('//')) return path;
  if (isPortalRoute(path)) return path;
  return `${getPortalWebUrl()}${path}`;
};
